var PENTA_T = window.PENTA_I18N || {};
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-burger]');
  if(b){document.querySelector('[data-mob]').classList.toggle('open');}
  var t=e.target.closest('.rev-tabs button');
  if(t){
    var g=t.closest('.rev-tabs');
    g.querySelectorAll('button').forEach(function(x){x.classList.remove('on')});
    t.classList.add('on');
    var f=t.dataset.filter||'';
    t.closest('section').querySelectorAll('.rev').forEach(function(r){
      r.style.display=(!f||r.dataset.usage===f)?'':'none';
    });
  }
  var th=e.target.closest('[data-thumb]');
  if(th){
    var gal=th.closest('.gal');
    gal.querySelectorAll('[data-thumb]').forEach(function(x){x.classList.remove('on')});
    th.classList.add('on');
    var main=gal.querySelector('[data-main-img]');
    if(main&&th.dataset.src){main.src=th.dataset.src; main.srcset='';}
  }
});
(function(){
  var atc=document.querySelector('[data-atc]'), bar=document.querySelector('[data-bar]');
  if(!atc||!bar||!('IntersectionObserver' in window))return;
  new IntersectionObserver(function(e){
    bar.classList.toggle('show', !e[0].isIntersecting && e[0].boundingClientRect.top<0);
  },{threshold:0}).observe(atc);
})();
(function(){
  var form=document.querySelector('[data-product-form]');
  if(!form)return;
  var data=document.querySelector('[data-variants]');
  if(!data)return;
  var variants=JSON.parse(data.textContent);
  var LOC=document.documentElement.lang||'en';
  var CUR=data.dataset.currency||'EUR';
  var lastMedia=null;
  var money=function(c){
    try{ return (c/100).toLocaleString(LOC,{style:'currency',currency:CUR}); }
    catch(e){ return (c/100).toFixed(2)+' '+CUR; }
  };
  function current(){
    var sel=[].map.call(form.querySelectorAll('[data-opt]:checked'),function(i){return i.value});
    return variants.filter(function(v){
      return sel.every(function(s,i){return v.options[i]===s});
    })[0];
  }
  function pack(){
    var q=form.querySelector('[data-pack]:checked');
    if(!q) return {qty:1, paid:1, pct:0};
    var qty=parseInt(q.value,10)||1;
    var paid=parseInt(q.dataset.paid,10);
    if(isNaN(paid)) paid=qty;
    var pct=parseInt(q.dataset.pct,10)||0;
    return {qty:qty, paid:paid, pct:pct};
  }
  function syncLabels(){
    form.querySelectorAll('[data-opt]:checked').forEach(function(inp){
      var wrap=inp.closest('.opt');
      if(!wrap)return;
      var s=wrap.querySelector('.opt-lbl span');
      if(s) s.textContent=inp.value;
    });
  }
  function showMedia(v){
    if(!v || !v.media_id) return;
    if(lastMedia === v.media_id) return;
    lastMedia = v.media_id;
    var gal=document.querySelector('.gal');
    if(!gal) return;
    var main=gal.querySelector('[data-main-img]');
    var target=gal.querySelector('[data-thumb][data-media-id="'+v.media_id+'"]');
    var src = target ? target.dataset.src : v.media_src;
    if(main && src){
      main.src=src;
      main.srcset='';
      if(v.media_alt) main.alt=v.media_alt;
    }
    gal.querySelectorAll('[data-thumb]').forEach(function(x){
      x.classList.toggle('on', x.dataset.mediaId === String(v.media_id));
    });
    if(target && target.scrollIntoView){
      try{ target.scrollIntoView({block:'nearest', inline:'nearest', behavior:'smooth'}); }catch(e){}
    }
  }
  function repriceCards(v){
    if(!v) return;
    form.querySelectorAll('[data-pack]').forEach(function(inp){
      var lab=form.querySelector('label[for="'+inp.id+'"]');
      if(!lab) return;
      var qty=parseInt(inp.value,10)||1;
      var paid=parseInt(inp.dataset.paid,10); if(isNaN(paid)) paid=qty;
      var pct=parseInt(inp.dataset.pct,10)||0;
      var net=Math.round(v.price*paid*(100-pct)/100);
      var full=v.price*qty;
      var net_el=lab.querySelector('.pack-net'); if(net_el) net_el.textContent=money(net);
      var per_el=lab.querySelector('.pack-per');
      if(per_el) per_el.textContent=money(Math.round(net/qty))+' '+(PENTA_T.perPair||'');
      var was=lab.querySelector('.pack-was');
      if(was) was.textContent=money(full);
    });
  }
  function render(){
    var v=current(), p=pack();
    var idInput=form.querySelector('[name="id"]');
    var qInput=form.querySelector('[name="quantity"]');
    var btn=form.querySelector('[data-atc]');
    var bar=document.querySelector('[data-bar-btn]');
    var priceEl=document.querySelector('[data-price]');
    syncLabels();
    if(qInput)qInput.value=p.qty;
    if(!v){ if(btn){btn.disabled=true;btn.textContent=PENTA_T.unavailable||'Unavailable';} return; }
    idInput.value=v.id;
    showMedia(v);
    repriceCards(v);
    var total=Math.round(v.price*p.paid*(100-p.pct)/100);
    if(priceEl){
      priceEl.innerHTML=money(total)+
        (v.compare_at_price&&v.compare_at_price>v.price?' <s>'+money(v.compare_at_price*p.qty)+'</s>':'')+
        (p.qty>1?' <span style="font-size:13px;color:var(--grey);font-weight:500">— '+money(Math.round(total/p.qty))+' '+(PENTA_T.perPair||'')+'</span>':'');
    }
    if(btn){
      btn.disabled=!v.available;
      btn.textContent=v.available?(btn.dataset.label||PENTA_T.addToCart||'Add to cart')+' — '+money(total):(PENTA_T.soldOut||'Sold out');
    }
    if(bar){bar.textContent=(PENTA_T.addShort||'Add')+' — '+money(total);}
    var meta=document.querySelector('[data-bar-meta]');
    if(meta){
      var prefix='';
      if(p.qty>1){ prefix=(PENTA_T.pairsCount||'%n% pairs').replace('%n%',p.qty)+' · '; }
      meta.textContent=prefix+v.title;
    }
  }
  form.addEventListener('change',render);
  var first=current();
  if(first) lastMedia = first.media_id;
  render();
})();
document.addEventListener('click',function(e){
  var o=e.target.closest('[data-open-modal]');
  if(o){
    var m=document.querySelector('[data-modal="'+o.dataset.openModal+'"]');
    if(m){m.hidden=false;document.body.style.overflow='hidden';}
    return;
  }
  if(e.target.closest('[data-close-modal]')){
    var mm=e.target.closest('.modal');
    if(mm){mm.hidden=true;document.body.style.overflow='';}
  }
});
document.addEventListener('keydown',function(e){
  if(e.key!=='Escape')return;
  document.querySelectorAll('.modal:not([hidden])').forEach(function(m){m.hidden=true});
  document.body.style.overflow='';
});
